/* eslint-disable camelcase */
import { Translate } from '@hooks/useI18n/types';

export interface IGetMerchantGuaranteed {
  is_allow_yellow_outcomes_risk_config?: boolean;
  is_merchant_guaranteed?: boolean;
  translate: Translate;
}

export const getMerchantGuaranteed = ({
  is_allow_yellow_outcomes_risk_config = false,
  is_merchant_guaranteed = false,
  translate,
}: IGetMerchantGuaranteed) => {
  if (!is_allow_yellow_outcomes_risk_config) {
    return {};
  }

  return {
    isMerchantGuaranteed: translate(
      `GENERAL.${is_merchant_guaranteed ? 'YES' : 'NO'}`,
    ),
  };
};
